import { useMemo } from 'react'
import { Col, Row } from 'antd'
import get from 'lodash/get'
import PropTypes from 'prop-types'

import ExpandIcon from '../Accordion/ExpandIcon'
import { ImageType } from '../types'
import { BlockSectionTitle, BlockWrapper, BynderPicture, Collapse, Container, CTALink, Panel, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


PortfolioDetailCollapsible.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
    text_blocks: PropTypes.arrayOf(PropTypes.shape({
      heading: PropTypes.string,
      text: PropTypes.string,
      cta_link_caption: PropTypes.string,
      cta_link: PropTypes.string,
      cta_link_type: PropTypes.string,
    })),
    image: ImageType,
  }),
}

export default function PortfolioDetailCollapsible({
  data = {
    text_blocks: [],
  },
}) {
  const items = useMemo(() => get(data, 'text_blocks', []).map(({
    heading,
    heading_hx: headingHx,
    text,
    cta_link_caption: ctaLinkCaption,
    cta_link: ctaLink,
    cta_link_type: ctaLinkType,
  }, ind) => (
    <Panel
      key={heading + ind}
      isClassless
      forceRender
      header={<Typography variant="subhead" tag={headingHx} className={classNames.title}>{heading}</Typography>}
      className={classNames.panel}
    >
      <Typography color="light-black">{text}</Typography>
      {ctaLinkCaption && ctaLink && (
        <CTALink
          cta={ctaLinkCaption}
          ctaURL={ctaLink}
          type={ctaLinkType}
          icon="chevron-right"
          className={classNames.cta}
        />
      )}
    </Panel>
  )), [data?.text_blocks])
  return (
    <BlockWrapper>
      <Container size="xl">
        <BlockSectionTitle heading={data.heading} headingHx={data.heading_hx} />
      </Container>
      <div className={classNames.wrapper}>
        <Row gutter={[40, 40]} className={classNames.content}>
          <Col span={0} md={2} />
          <Col span={24} md={12}>
            <Collapse accordion expandIcon={ExpandIcon}>
              {items}
            </Collapse>
          </Col>
        </Row>
        <div
          className={classNames.image}
        >
          <BynderPicture
            image={data.image}
            priority
            desktopImage={{
              maxWidth: 900,
              maxHeight: 600,
              sizes: '(max-width: 769px) 100vw, (max-width: 1440px) 70vw, 900px',
            }}
            mobileImage={{
              maxWidth: 600,
              maxHeight: 600,
              sizes: '100vw',
            }}
          />
        </div>
      </div>
    </BlockWrapper>
  )
}
